import { Icons, Stack, Typography } from '@healthinal/ui';
import { ReactNode } from 'react';
import {
  TherapyMedicationChangeDto,
  TherapyMedicationChangeDtoTherapyPhase,
  TherapyMedicationDto,
} from '../../../api/generated/model';
import { SubCard } from '../../../components/SubCard.tsx';
import { theme } from '../../../theme.ts';

export function MedicationChangeComparison({ medicationChange }: { medicationChange: TherapyMedicationChangeDto }) {
  return (
    <Stack direction={'row'} gap={1}>
      <Stack flex={1}>
        <Typography level={'body-sm'}>Vorher</Typography>
        <BeforeMedicationCard
          medicationBefore={medicationChange.beforeState}
          medicationAfter={medicationChange.afterState}
          phase={medicationChange.therapyPhase}
        />
      </Stack>
      <Icons.ArrowForward sx={{ alignSelf: 'center', marginTop: theme.spacing(3) }} />
      <Stack flex={1}>
        <Typography level={'body-sm'}>Nachher</Typography>
        <AfterMedicationCard
          medicationBefore={medicationChange.beforeState}
          medicationAfter={medicationChange.afterState}
          phase={medicationChange.therapyPhase}
        />
      </Stack>
    </Stack>
  );
}

function BeforeMedicationCard({
  medicationBefore,
  medicationAfter,
  phase,
}: {
  medicationBefore: TherapyMedicationDto[];
  medicationAfter: TherapyMedicationDto[];
  phase: TherapyMedicationChangeDtoTherapyPhase;
}) {
  return (
    <MedicationCard phase={phase}>
      <Stack>
        {medicationBefore.map((med) => (
          <Typography
            key={med.id}
            level={'body-sm'}
            color={medicationAfter.some((after) => after.medication.id === med.medication.id) ? 'neutral' : 'danger'}>
            {med.medication.name}
          </Typography>
        ))}
      </Stack>
    </MedicationCard>
  );
}

function AfterMedicationCard({
  medicationBefore,
  medicationAfter,
  phase,
}: {
  medicationBefore: TherapyMedicationDto[];
  medicationAfter: TherapyMedicationDto[];
  phase: TherapyMedicationChangeDtoTherapyPhase;
}) {
  return (
    <MedicationCard phase={phase}>
      <Stack>
        {medicationAfter.map((med) => (
          <Typography
            key={med.id}
            level={'body-sm'}
            color={
              medicationBefore.some((before) => before.medication.id === med.medication.id) ? 'neutral' : 'success'
            }>
            {med.medication.name}
          </Typography>
        ))}
      </Stack>
    </MedicationCard>
  );
}

function MedicationCard({ phase, children }: { phase: TherapyMedicationChangeDtoTherapyPhase; children: ReactNode }) {
  return (
    <SubCard sx={{ height: '100%' }}>
      <Typography level={'title-sm'}>
        Medikation Phase {phase === TherapyMedicationChangeDtoTherapyPhase.PHASE_1 ? '1' : '2'}
      </Typography>
      {children}
    </SubCard>
  );
}
